import { render } from "./ReceiverFabs.vue?vue&type=template&id=5001fb4f"
import script from "./ReceiverFabs.vue?vue&type=script&lang=js"
export * from "./ReceiverFabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/review/components/receiver/ReceiverFabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5001fb4f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5001fb4f', __exports__)) {
    api.reload('5001fb4f', __exports__)
  }
  
  module.hot.accept("./ReceiverFabs.vue?vue&type=template&id=5001fb4f", () => {
    api.rerender('5001fb4f', render)
  })

}


export default __exports__